import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { Context } from '../../service/Context';

/**
 * Componente que protege las rutas de la aplicación.
 * Si el usuario no ha iniciado sesión, lo redirige a la página de inicio de sesión.
 * Si ha iniciado sesión, renderiza el componente hijo.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {React.ReactNode} props.children - Componentes hijos a renderizar si está autenticado.
 */
const ProtectedRoute = ({ children }) => {
  const { idUsuario } = useContext(Context);

  if (!idUsuario) {
    return <Navigate to="/iniciosesion" replace />;
  }

  return children;
};

export default ProtectedRoute;
